/**
 * Handles the copy event for texts that are shorten
 * @param text
 */
function handleCopy(text) {
  const currentSelection = window.getSelection();
  const currentSelectedText = currentSelection.anchorNode.data.substring(
    currentSelection.focusOffset,
    currentSelection.baseOffset,
  );
  const hasEllipsis = currentSelectedText.indexOf('…') !== -1;

  if (hasEllipsis) {
    const indexInFullText = text.match(currentSelectedText.replace('…', '')).index;

    navigator.clipboard.writeText(text.substring(indexInFullText));
  }
}

export default handleCopy;
